import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Home, BookOpen } from "lucide-react";

export default function NotFoundPage() {
    return (
        <div className="min-h-screen bg-background flex flex-col items-center justify-center px-6 py-24 text-center">
            {/* Decorative blobs */}
            <div
                aria-hidden="true"
                className="pointer-events-none absolute inset-0 overflow-hidden"
            >
                <div className="absolute -top-32 -left-32 w-[500px] h-[500px] rounded-full bg-aiblue/5 blur-3xl" />
                <div className="absolute -bottom-32 -right-32 w-[500px] h-[500px] rounded-full bg-aiorange/5 blur-3xl" />
            </div>

            <motion.div
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="relative flex flex-col items-center gap-6 max-w-lg"
            >
                {/* 404 number */}
                <div className="relative select-none">
                    <span
                        className="text-[9rem] sm:text-[12rem] font-black leading-none tracking-tighter text-transparent bg-clip-text"
                        style={{
                            backgroundImage:
                                "linear-gradient(135deg, #0052FF 0%, #FF6B00 100%)",
                        }}
                    >
                        404
                    </span>
                    <span className="absolute inset-0 text-[9rem] sm:text-[12rem] font-black leading-none tracking-tighter text-gray-100 -z-10 translate-x-1 translate-y-1">
                        404
                    </span>
                </div>

                {/* Heading */}
                <h1 className="text-2xl sm:text-3xl font-bold text-foreground -mt-4">
                    Page Not Found
                </h1>

                {/* Description */}
                <p className="text-muted-foreground text-base sm:text-lg leading-relaxed">
                    The page you're looking for doesn't exist or may have been
                    moved. Let's get you back on track.
                </p>

                {/* Action buttons */}
                <div className="flex flex-wrap items-center justify-center gap-3 mt-2">
                    <Link
                        to="/"
                        className="inline-flex items-center gap-2 rounded-full bg-aiblue text-white px-6 py-3 text-sm font-semibold hover:bg-blue-700 transition-colors"
                    >
                        <Home size={16} />
                        Go to Home
                    </Link>
                    <Link
                        to="/programmes"
                        className="inline-flex items-center gap-2 rounded-full border border-gray-300 text-foreground px-6 py-3 text-sm font-semibold hover:border-aiblue hover:text-aiblue transition-colors"
                    >
                        <BookOpen size={16} />
                        Browse Programmes
                    </Link>
                </div>

                {/* Quick nav */}
                <p className="text-xs text-muted-foreground mt-4">
                    Or explore:{" "}
                    {[
                        { label: "About", href: "/about" },
                        { label: "Careers", href: "/careers" },
                        { label: "Waitlist", href: "/waitlist" },
                    ].map((link, i, arr) => (
                        <span key={link.href}>
                            <Link
                                to={link.href}
                                className="underline underline-offset-2 hover:text-aiblue transition-colors"
                            >
                                {link.label}
                            </Link>
                            {i < arr.length - 1 && (
                                <span className="mx-1 text-gray-300">·</span>
                            )}
                        </span>
                    ))}
                </p>
            </motion.div>
        </div>
    );
}
